/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import styled, { css } from "styled-components";
import Stack from "./Stack";

const toneBorderStyles = {
  accent: css`
    border-color: rgba(${({ theme }) => theme.colors.accent.rgba});
  `,
  neutral: css`
    border-color: rgba(${({ theme }) => theme.colors.border.rgba});
  `,
  success: css`
    border-color: rgba(${({ theme }) => theme.colors.success.rgba});
  `,
  warning: css`
    border-color: rgba(${({ theme }) => theme.colors.warning.rgba});
  `,
  error: css`
    border-color: rgba(${({ theme }) => theme.colors.error.rgba});
  `,
};

const SectionedCard = styled.div`
  position: relative;
  border: 1px solid rgba(${({ theme }) => theme.colors.border.rgba});
  border-radius: 16px;

  ${({ $tone }) => $tone && toneBorderStyles[$tone]}
`;

const SectionedCardHeader = styled.div`
  padding: 1.5rem;
  border-bottom: 1px solid rgba(${({ theme }) => theme.colors.border.rgba});
`;

const SectionedCardBody = styled(Stack)`
  padding: 1rem 1.5rem;
`;

const SectionedCardFooter = styled.div`
  padding: 1rem 1.5rem;
`;

export { SectionedCard, SectionedCardHeader, SectionedCardBody, SectionedCardFooter };
